import {
  CV_APP_TYPE_EVENT,
  CVAPP_CAMERAADJUSTMENT,
  CVAPP_CROWDDENSITY,
  CVAPP_DWELLTIME,
  CVAPP_OBJECTDETECTION,
  CVAPP_PARKINGOCCUPANCYEE,
  CVAPP_PARKINGOCCUPANCYOA,
  CVAPP_PEOPLE_COUNT_EE,
  CVAPP_PEOPLE_COUNT_OA,
  CVAPP_PERSON_DETECTION,
  CVAPP_PPEUSAGE,
  CVAPP_PROXIMITY,
  CVAPP_SLIPANDFALL,
  CVAPP_UNOBJECTDETECTION,
  CVAPP_VEHICLE_DETECTION,
  CVAPP_VEHICLECOUNTEE,
  CVAPP_VEHICLECOUNTOA,
  CVAPP_WATERLEAK_DETECTION,
  CV_APP_TYPE_EE,
  CV_APP_TYPE_OA,
} from "../constants/cvappConstants";
import { getFullCVAppName } from "./Utils";

export const getCvAppCategory = (cvappList, id) => {
  const app = cvappList && cvappList?.find((app) => app?.id === id);
  if (app) {
    if (
      app?.category === "Statistics Apps" &&
      app?.subcategory == "Entry Exit"
    ) {
      return "Entry Exit";
    } else if (app?.category === "Statistics Apps") {
      return "Fixed Area";
    } else {
      return app?.category;
    }
  }
};

export const getcvAppDetails = (cvappList, id) => {
  const app = cvappList && cvappList?.find((app) => app?.id === id);
  if (!app) {
    return "NA";
  }
  if (app?.category === "Event Apps") {
    return `${app?.image}.status`;
  } else if (app?.category === "Privacy Apps") {
    return `${app?.image}`;
  } else if (app?.category === "Extra Features") {
    return `${app?.image}.status`;
  } else if (app?.name === CVAPP_DWELLTIME) {
    const statisticParameters =
      app.configtemplate.schema?.properties?.["statistic-parameters"];
    if (statisticParameters && statisticParameters?.properties) {
      return `${app?.image}.average`;
    } else {
      return `${app?.image}.average`;
    }
  } else if (app?.name === CVAPP_VEHICLECOUNTOA) {
    return `${app?.image}.count`; //need to change this once we got the correct value in cvapp template
  } else if (app?.configtemplate && app?.configtemplate?.schema) {
    const statisticParameters =
      app.configtemplate.schema?.properties?.["statistic-parameters"];
    if (statisticParameters && statisticParameters?.properties) {
      const firstkey = Object.keys(statisticParameters?.properties)[0];
      if (firstkey) {
        return `${app?.image}.${firstkey}`;
      } else {
        return `${app?.image}.count`;
      }
    }
  }
};

export const getcvAppImage = (cvappList, id) => {
  const app = cvappList && cvappList?.find((app) => app?.id == id);
  if (!app) {
    return "NA";
  } else {
    return app?.image;
  }
};

export const getcvAppName = (cvappList, id) => {
  const app = cvappList && cvappList?.find((app) => app?.id == id);
  if (!app) {
    return "NA";
  } else {
    return app?.name;
  }
};

export const getcvAppDispName = (cvappList, id) => {
  const app = cvappList && cvappList?.find((app) => app?.id === id);
  if (!app) {
    return "NA";
  } else {
    return app?.resources?.displayName || app?.name;
  }
};

export const getcvAppDisplayName = (cvappList, id) => {
  const app = cvappList && cvappList?.find((app) => app?.id == id);
  if (!app) {
    return "NA";
  } else {
    return app?.resources?.displayNameFull || app?.name;
  }
};

export const getCvAppTemplateforTitleInfo = (cvAppList, cvappid) => {
  const app = cvAppList && cvAppList?.find((app) => app?.id === cvappid);
  if (!app) {
    return "NA";
  }
  const statisticParameters =
    app?.configtemplate?.schema?.properties?.["statistic-parameters"];
  if (app?.name == CVAPP_PPEUSAGE) {
    const objectclass = statisticParameters?.properties?.objectclass;
    if (objectclass) {
      return "objectclass";
    }
  } else if (app?.name == CVAPP_OBJECTDETECTION) {
    const objectclass = statisticParameters?.properties?.objects;
    if (objectclass) {
      return "objects";
    }
  } else if (app?.name == CVAPP_UNOBJECTDETECTION) {
    return "objects";
  }
};

export const convertToMMSS = (input) => {
  const value = parseInt(input.slice(0, -1));
  const unit = input.slice(-1);

  let totalSeconds = 0;

  if (unit === "m") {
    totalSeconds = value * 60;
  } else if (unit === "s") {
    totalSeconds = value;
  } else if (unit === "h") {
    totalSeconds = value * 3600;
  } else {
    return 0;
  }

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  // Format as MM:SS
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
    2,
    "0"
  )}`;
};

export const getCvAppTitle = (cvAppList, cvAppId) => {
  const appName = getFullCVAppName(cvAppId, cvAppList);
  if (appName !== "NA") {
    if (
      appName == CVAPP_PEOPLE_COUNT_OA ||
      appName == CVAPP_PEOPLE_COUNT_EE ||
      appName == CVAPP_CROWDDENSITY
    ) {
      return "Excess people count";
    } else if (
      appName == CVAPP_VEHICLECOUNTOA ||
      appName == CVAPP_VEHICLECOUNTEE
    ) {
      return "Excess vehicle count";
    } else if (
      appName == CVAPP_PARKINGOCCUPANCYOA ||
      appName == CVAPP_PARKINGOCCUPANCYEE
    ) {
      return "Excess occupancy count";
    } else if (appName == CVAPP_DWELLTIME) {
      return "Excess dwell time";
    } else if (appName == CVAPP_SLIPANDFALL) {
      return "Slip and Fall detected";
    } else if (appName == CVAPP_PERSON_DETECTION) {
      return "Person detected";
    } else if (appName == CVAPP_VEHICLE_DETECTION) {
      return "Vehicle detected";
    } else if (appName == CVAPP_PPEUSAGE) {
      return "Missing PPE detected";
      // return `$.concat(\"Missing \" ,$..eventMsg.fields.${getcvAppImage(
      //   cvAppList,
      //   cvAppId
      // )}.objectType, \" detected \")`;
    } else if (appName == CVAPP_OBJECTDETECTION) {
      return `$.concat($..eventMsg.fields.${getcvAppImage(
        cvAppList,
        cvAppId
      )}.objectType,\" ,detected \")`;
    } else if (appName == CVAPP_UNOBJECTDETECTION) {
      return `$.concat(\"Unattended \" ,$..eventMsg.fields.${getcvAppImage(
        cvAppList,
        cvAppId
      )}.objectType, \" detected \")`;
    } else if (appName == CVAPP_PROXIMITY) {
      return "Proximity event";
    } else if (appName == CVAPP_CAMERAADJUSTMENT) {
      return "Camera stream adjusted";
    } else if (appName === CVAPP_WATERLEAK_DETECTION) {
      return "Water Leak detected"
    } 
    else {
      return "Event detected";
    }
  }
};

export const getAlertEventInfo = (
  cvAppList,
  cvAppId,
  areaName,
  value,
  condition,
  duration
) => {
  const appName = getFullCVAppName(cvAppId, cvAppList);
  if (
    appName == CVAPP_PEOPLE_COUNT_OA ||
    appName == CVAPP_PEOPLE_COUNT_EE ||
    appName == CVAPP_CROWDDENSITY
  ) {
    return `$.concat($..eventMsg.fields.${getcvAppImage(
      cvAppList,
      cvAppId
    )}.count,\" ,people detected in ${areaName}\")`;
  } else if (
    appName == CVAPP_VEHICLECOUNTOA ||
    appName == CVAPP_VEHICLECOUNTEE
  ) {
    return `$.concat($..eventMsg.fields.${getcvAppImage(
      cvAppList,
      cvAppId
    )}.count,\" ,vehicles detected in ${areaName}\")`;
  } else if (
    appName == CVAPP_PARKINGOCCUPANCYOA ||
    appName == CVAPP_PARKINGOCCUPANCYEE
  ) {
    return `Parking occupancy in ${areaName} is ${
      condition ? condition.toLowerCase() : "greater than"
    } ${value}`;
  } else if (appName == CVAPP_DWELLTIME) {
    return `Dwell time in ${areaName} is ${
      condition ? condition.toLowerCase() : "greater than"
    } ${convertToMMSS(duration)}`;
  } else {
    return `Event occured in ${areaName}`;
  }
};

export const getcvAppTemplateValue = (cvappList, id) => {
  const app = cvappList && cvappList?.find((app) => app?.id === id);
  if (!app) {
    return "NA";
  }
  if (app?.category === "Event Apps" && app?.name == CVAPP_PROXIMITY) {
    const deployParameters =
      app.configtemplate.schema?.properties?.["deploy-parameters"];
    if (deployParameters && deployParameters?.properties) {
      const distanceAllowed = deployParameters.properties["distance_allowed"];
      if (distanceAllowed) {
        return {
          default: distanceAllowed?.default,
          minimum: distanceAllowed?.minimum || 0,
        };
      }
    }
  }
};

export const getCvAppInfo = (cvAppList, cvAppId) => {
  const app = cvAppList && cvAppList?.find((app) => app?.id === cvAppId);
  if (!app) {
    return "NA";
  }
  if (
    app?.name === CVAPP_PERSON_DETECTION ||
    app?.name === CVAPP_VEHICLE_DETECTION
  ) {
    const deployParameters =
      app.configtemplate.schema?.properties?.["deploy-parameters"];
    return deployParameters?.properties?.colors?.items?.enum;
  }
  return null;
};

export const generateConditionString = (
  selectedObjects,
  cvappid,
  cvappList,
  appName
) => {
  const cvAppImage = getcvAppImage(cvappList, cvappid);
  let condition = "";
  if (appName === CVAPP_PPEUSAGE) {
    const objectsArray = Array.isArray(selectedObjects)
      ? selectedObjects
      : [selectedObjects];
    if (
      !objectsArray ||
      (Array.isArray(objectsArray) && objectsArray.length === 0)
    ) {
      return false;
    }
    let condition = "";
    objectsArray?.forEach((object, index) => {
      if (index === 0) {
        condition += `@.eventMsg.fields.${cvAppImage}.objectclass == '${object}'`;
      } else {
        condition += ` && @.eventMsg.fields.${cvAppImage}.objectclass == '${object}'`;
      }
    });
    return condition;
  }
  return condition;
};

export const getCustomerMessage = (cvAppList, cvAppId) => {
  const appName = getFullCVAppName(cvAppId, cvAppList);
  if (appName !== "NA") {
    if (
      appName == CVAPP_PEOPLE_COUNT_OA ||
      appName == CVAPP_PEOPLE_COUNT_EE ||
      appName == CVAPP_CROWDDENSITY
    ) {
      return "Excess people count";
    } else if (
      appName == CVAPP_VEHICLECOUNTOA ||
      appName == CVAPP_VEHICLECOUNTEE
    ) {
      return "Excess vehicle count";
    } else if (
      appName == CVAPP_PARKINGOCCUPANCYOA ||
      appName == CVAPP_PARKINGOCCUPANCYEE
    ) {
      return "Excess occupancy count";
    } else if (appName == CVAPP_DWELLTIME) {
      return "Excess dwell time";
    } else if (appName == CVAPP_SLIPANDFALL) {
      return "Slip and Fall detected";
    } else if (appName == CVAPP_PERSON_DETECTION) {
      return "Person detected";
    } else if (appName == CVAPP_VEHICLE_DETECTION) {
      return "Vehicle detected";
    } else if (appName == CVAPP_PPEUSAGE) {
      return "Missing PPE detected";
      // `Missing {{$.eventMsg.fields.${getcvAppImage(
      //   cvAppList,
      //   cvAppId
      // )}.objectType}} detected`;
    } else if (appName == CVAPP_OBJECTDETECTION) {
      return `{{$.eventMsg.fields.${getcvAppImage(
        cvAppList,
        cvAppId
      )}.objectType}} detected`;
    } else if (appName == CVAPP_UNOBJECTDETECTION) {
      return `Unattended {{$.eventMsg.fields.${getcvAppImage(
        cvAppList,
        cvAppId
      )}.objectType}} detected`;
    } else if (appName == CVAPP_PROXIMITY) {
      return "Proximity event";
    } else if (appName == CVAPP_CAMERAADJUSTMENT) {
      return "Camera stream adjusted";
    } else if (appName === CVAPP_WATERLEAK_DETECTION) {
      return "Water Leak detected"
    } else {
      return "Event detected";
    }
  }
};

export const isEntryExitApp = (cvAppList, appid) => {
  const app = cvAppList && cvAppList?.find((app) => app?.id === appid);
  if (
    app &&
    app?.category === "Statistics Apps" &&
    app?.subcategory === "Entry Exit"
  ) {
    return true;
  } else return false;
};

export const getCVAppType = (cvAppList, appId) => {
  const appType = getCvAppCategory(cvAppList, appId);
  if (appType === "Entry Exit" || appType === "EntryExit") {
    return CV_APP_TYPE_EE;
  } else if (appType === "Fixed Area" || appType === "FixedArea") {
    return CV_APP_TYPE_OA;
  } else {
    return CV_APP_TYPE_EVENT;
  }
};

export const getLocationHierarchyWithIds = (siteTagList, locationTag) => {
  let hierarchy = {};

  // Check for matching subarea
  let matchingSubarea = siteTagList?.subareas?.find(
    (item) => item.id === locationTag
  );
  if (matchingSubarea) {
    hierarchy.subarea = matchingSubarea?.id;
    let matchingArea = siteTagList?.areas?.find(
      (item) => item.id === matchingSubarea?.tagids?.[0]
    );
    if (matchingArea) {
      hierarchy.area = matchingArea?.id;
      let matchingFloor = siteTagList?.floors?.find(
        (item) => item.id === matchingArea?.tagids?.[0]
      );
      if (matchingFloor) {
        hierarchy.floor = matchingFloor?.id;
        let matchingSite = siteTagList?.sites?.find(
          (item) => item.id === matchingFloor?.tagids?.[0]
        );
        if (matchingSite) {
          hierarchy.site = matchingSite?.id;
        }
      }
    }
    return hierarchy;
  }

  // Check for matching area
  let matchingArea = siteTagList?.areas?.find(
    (item) => item.id === locationTag
  );
  if (matchingArea) {
    hierarchy.area = matchingArea?.id;
    let matchingFloor = siteTagList?.floors?.find(
      (item) => item.id === matchingArea?.tagids?.[0]
    );
    if (matchingFloor) {
      hierarchy.floor = matchingFloor?.id;
      let matchingSite = siteTagList?.sites?.find(
        (item) => item.id === matchingFloor?.tagids?.[0]
      );
      if (matchingSite) {
        hierarchy.site = matchingSite?.id;
      }
    }
    return hierarchy;
  }

  // Check for matching floor
  let matchingFloor = siteTagList?.floors?.find(
    (item) => item.id === locationTag
  );
  if (matchingFloor) {
    hierarchy.floor = matchingFloor?.id;
    let matchingSite = siteTagList?.sites?.find(
      (item) => item.id === matchingFloor?.tagids?.[0]
    );
    if (matchingSite) {
      hierarchy.site = matchingSite?.id;
    }
    return hierarchy;
  }

  // Check for matching site
  let matchingSite = siteTagList?.sites?.find(
    (item) => item.id === locationTag
  );
  if (matchingSite) {
    hierarchy.site = matchingSite?.id;
    return hierarchy;
  }
  return hierarchy;
};

export const buildDeviceIdExpression = (deviceIds) => {
  if (!Array.isArray(deviceIds) || deviceIds.length === 0) return "";

  if (deviceIds?.length === 1) {
    return `$[?(@.eventHeaders.deviceid == '${deviceIds[0]}')]`;
  }

  const conditions = deviceIds
    ?.map((id) => `@.eventHeaders.deviceid == '${id}'`)
    ?.join(" || ");

  return `$[?(${conditions})]`;
};

export const isCvAppFromInHouseVersion = (cvappList, cvappId) =>{
  const cv_app = cvappList.find(app => app.id === cvappId);
  const appVersion = cv_app?.version;
  if(appVersion.includes('.') && appVersion.split(".")[0]){
    if(parseInt(appVersion.split(".")[0]) > 1){
      return true;
    }
  }else{
    if(parseInt(appVersion) > 1){
      return true;
    }
  }
  return false;
}
